import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const lineReveal = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: 0,
    transition: { duration: 1.1, delay: 0.2 + i * 0.16, ease: [0.25, 1, 0.5, 1] },
  }),
};

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "16%"]);

  return (
    <section id="top" ref={ref} className="pt-24 pb-6 px-4 sm:px-6 lg:px-10 bg-[#FAFAF8]" data-testid="hero-section">
      <div className="relative max-w-7xl mx-auto rounded-3xl overflow-hidden min-h-[82vh] flex items-center">
        <motion.div style={{ y: imgY }} className="absolute inset-0">
          <img
            src="/images/kshama-2.webp"
            alt="Dr. Kshama Chandan"
            className="w-full h-[112%] object-cover object-[70%_22%]"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0E0E0E]/95 via-[#0E0E0E]/75 to-[#0E0E0E]/25" />
        </motion.div>

        <div className="relative z-10 w-full px-8 sm:px-12 lg:px-16 py-20">
          <span className="hero-mask-line">
            <motion.span
              custom={0}
              variants={lineReveal}
              initial="hidden"
              animate="visible"
              className="inline-block font-heading text-xs sm:text-sm font-bold tracking-[0.25em] uppercase text-[#E7CE96] mb-6"
            >
              Mentorship for Dentists · Across India &amp; Online
            </motion.span>
          </span>

          <h1 className="font-heading font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight max-w-3xl" data-testid="hero-title">
            <span className="hero-mask-line">
              <motion.span custom={1} variants={lineReveal} initial="hidden" animate="visible" className="inline-block">
                Master the Art &amp; Science of
              </motion.span>
            </span>
            <span className="hero-mask-line">
              <motion.span custom={2} variants={lineReveal} initial="hidden" animate="visible" className="inline-block">
                <em className="font-semibold">Smile Transformations</em>
              </motion.span>
            </span>
            <span className="hero-mask-line">
              <motion.span custom={3} variants={lineReveal} initial="hidden" animate="visible" className="inline-block">
                with Dr. Kshama Chandan
              </motion.span>
            </span>
          </h1>

          <span className="hero-mask-line mt-7">
            <motion.p
              custom={4}
              variants={lineReveal}
              initial="hidden"
              animate="visible"
              className="max-w-xl text-white/90 text-base sm:text-lg leading-relaxed"
            >
              Learn aesthetic dentistry with Dr. Kshama through advanced hands-on and online
              programs on porcelain veneers, smile designing, teeth whitening, practice growth
              and one-on-one internship programs.
            </motion.p>
          </span>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 1.1, ease: [0.25, 1, 0.5, 1] }}
            className="mt-10 flex flex-wrap items-center gap-6"
          >
            <a
              href="#courses"
              onClick={(e) => { e.preventDefault(); document.querySelector("#courses")?.scrollIntoView({ behavior: "smooth" }); }}
              data-testid="hero-explore-courses-btn"
              className="font-heading font-bold text-base bg-[#C6A45C] text-[#0E0E0E] px-8 py-4 rounded-xl hover:bg-[#A88743] transition-colors duration-300"
            >
              Explore Courses
            </a>
            <p className="font-heading text-sm font-medium text-white/85" data-testid="hero-trust-line">
              Trusted By Over <strong className="text-white">10,000+ Dentists</strong>
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
